/* global document */
'use strict';

import Actions from './actions';
import Button from '../../../components/form/button.jsx';
import ControlGroup from '../../../components/form/control-group.jsx';
import React from 'react';
import Spinner from '../../../components/form/spinner.jsx';
import TextControl from '../../../components/form/text-control.jsx';
import PropTypes from 'prop-types';
import Store from './store';


const propTypes = {

    error: PropTypes.string,
    loading : PropTypes.bool,
    success : PropTypes.bool,
    hasError : PropTypes.object,
    help : PropTypes.object,
    cancel: PropTypes.func,
    signinComplete: PropTypes.func
};

class Signin extends React.Component {
    constructor(props) {

        super(props);

        this.input = {};
    }

    componentDidMount() {

        if (this.input.username) {
            this.input.username.focus();
        }
    }

    handleSubmit(event) {

        event.preventDefault();
        //event.stopPropagation();

        /*
        let c;
        if ( window.PasswordCredential) {

            c = new PasswordCredential(event.target);

        }*/

        Actions.postSignin({
            username: this.input.username.value(),
            password: this.input.password.value(),
            stay: this.input.stay.checked
        }, Store, (err) => {
            document.location.reload();
            /*
            if ( !err && window.PasswordCredential) {
                navigator.credentials.store(c).then((r) => {
                    console.log('\nhey 3', r);

                }, ( err ) => {
                    console.log(err);

                });

            }*/
        });
    }

    /*
    cancel() {
        Actions.cancelCheckout();
    }*/

    forgot(event) {

        event.preventDefault();
        event.stopPropagation();
        Actions.forgot();
    }

    render() {

        const alerts = [];

        if (this.props.success) {
            alerts.push(<div key="success" className="alert alert-success">
                Signin Successful.
            </div>);
        }
        else if (this.props.error) {
            alerts.push(<div key="danger" className="alert alert-danger">
                {this.props.error}
            </div>);
        }

        let formElements;

        if (!this.props.success) {
            formElements =
                <form action="/api/login" method="post" onSubmit={this.handleSubmit.bind(this)}>
                    <fieldset>
                        <TextControl
                            ref={(c) => (this.input.username = c)}
                            name="username"
                            autoComplete="username email"
                            label="Email"
                            hasError={this.props.hasError.username}
                            help={this.props.help.username}
                            disabled={this.props.loading}
                        />
                        <TextControl
                            ref={(c) => (this.input.password = c)}
                            name="password"
                            label="Password"
                            autoComplete="current-password"
                            type="password"
                            hasError={this.props.hasError.password}
                            help={this.props.help.password}
                            disabled={this.props.loading}
                        />
                        <div className="form-group inline-checkbox">

                            <label
                                htmlFor={this.input.stay}
                                className="inline-checkbox"
                            ><input name='stay'
                                    className="inline-checkbox"
                                    defaultChecked
                                    type='checkbox'
                                    ref={(c) => (this.input.stay = c)}
                                />
                        Stay signed in</label>
                        </div>
                        <ControlGroup hideLabel={true} hideHelp={true}>
                            <Button
                                type="submit"
                                inputClasses={{ 'btn-primary': true }}
                                disabled={this.props.loading}>

                        Sign in
                                <Spinner space="left" show={this.props.loading} />
                            </Button> <Button
                                type="button"
                                onClick={this.props.cancel}
                                inputClasses={{ 'btn-default': true }}
                                disabled={this.props.loading}>

                        Cancel
                            </Button>
                            <a to="/login/forgot" onClick={this.forgot} className="btn btn-link">Forgot your password?</a>
                        </ControlGroup>
                    </fieldset>
                </form>;
        }
        else {
            formElements = (
                <div className="page-title">
                    <button onClick={this.props.signinComplete} className="btn btn-primary">Continue</button>
                </div>
            );
        }

        return (
            <section className='sor-signin'>
                {alerts}
                {formElements}
            </section>
        );
    }
}

Signin.propTypes = propTypes;

export default Signin;
